(function () {
  "use strict";

  var viewed = new Set();

  function parsePayload(script) {
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getPayloadMap() {
    var map = {};
    document.querySelectorAll("script[data-ga-promotion]").forEach(function (script) {
      var payload = parsePayload(script);
      if (!payload || !payload.promotion_id) return;
      map[payload.promotion_id] = payload;
    });
    return map;
  }

  function pushViewPromotion(payload) {
    if (!payload || viewed.has(payload.promotion_id)) return;
    viewed.add(payload.promotion_id);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "view_promotion",
      ecommerce: {
        promotion_id: payload.promotion_id,
        promotion_name: payload.promotion_name,
        creative_name: payload.creative_name,
        creative_slot: payload.creative_slot,
        location_id: payload.location_id
      }
    });
  }

  function pushSelectPromotion(payload) {
    if (!payload || !payload.promotion_id) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "select_promotion",
      ecommerce: {
        promotion_id: payload.promotion_id,
        promotion_name: payload.promotion_name,
        creative_name: payload.creative_name,
        creative_slot: payload.creative_slot,
        location_id: payload.location_id,
        campaign_name: payload.campaign_name || payload.promotion_name
      }
    });
  }

  function observePromotionBanners(payloadMap) {
    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          var id = entry.target.getAttribute("data-ga-promotion-id");
          if (!id || !payloadMap[id]) return;
          pushViewPromotion(payloadMap[id]);
        });
      },
      { threshold: [0.5] }
    );

    document.querySelectorAll("[data-ga-promotion-id]").forEach(function (el) {
      if (el.matches("script[data-ga-promotion]")) return;
      observer.observe(el);
    });
  }

  function bindPromotionClicks(payloadMap) {
    document.addEventListener(
      "click",
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var banner = target.closest("[data-ga-promotion-id]");
        if (!banner || banner.matches("script[data-ga-promotion]")) return;

        var link = target.closest("a[href]");
        if (!link || !banner.contains(link)) return;

        var id = banner.getAttribute("data-ga-promotion-id");
        if (!id || !payloadMap[id]) return;

        pushSelectPromotion(payloadMap[id]);
      },
      true
    );
  }

  function init() {
    var payloadMap = getPayloadMap();
    if (!Object.keys(payloadMap).length) return;

    observePromotionBanners(payloadMap);
    bindPromotionClicks(payloadMap);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
